import { render, staticRenderFns } from "./ChevronLeftIcon.vue?vue&type=template&id=3b34a06e&scoped=true&"
import script from "./ChevronLeftIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChevronLeftIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34a06e",
  null
  
)

export default component.exports